<template>
    <div class="z-50 bg-white dark:bg-sandstone-800 shadow-65">
        <div
            class="flex w-[90%] max-w-screen-2xl mx-auto justify-between items-center px-8 transition-all"
            :class="{ 'py-0.5': type === 'small', 'py-2': type === 'large' }"
        >
            <div class="grow flex-1">
                <ul class="flex gap-8 items-center">
                    <li class="text-center flex gap-8 justify-center">
                        <LayoutsDefaultCartIcon />
                        <div>
                            <ClientOnly>
                                <LazyWidgetsLoginButton />
                            </ClientOnly>
                        </div>
                    </li>
                </ul>
            </div>
            <div>
                <ul class="flex items-center gap-4">
                    <li class="w-32 flex-1 text-center">
                        <NuxtLink to="/" :class="{ 'text-sm transition-all': type === 'small' }"> خانه </NuxtLink>
                    </li>
                    <li class="w-32 flex-1 text-center">
                        <UButton
                            variant="link"
                            icon="i-solar-alt-arrow-down-outline"
                            trailing
                            color="black"
                            :class="{ 'text-sm transition-all': type === 'small' }"
                            @click="handleOpenCategory"
                        >
                            محصولات
                        </UButton>
                    </li>
                    <li class="flex-1 px-8 flex justify-center">
                        <NuxtLink
                            to="/"
                            aria-label="خانه"
                            class="flex justify-center items-center transition-all"
                            :class="{ 'w-24': type === 'small', 'w-40': type === 'large' }"
                        >
                            <UiLogo class="w-full" />
                        </NuxtLink>
                    </li>
                    <li class="w-32 flex-1 text-center">
                        <NuxtLink to="/about" :class="{ 'text-sm transition-all': type === 'small' }">
                            درباره‌ما
                        </NuxtLink>
                    </li>
                    <li class="w-32 flex-1 text-center">
                        <NuxtLink to="/contact" :class="{ 'text-sm transition-all': type === 'small' }">
                            تماس با ما
                        </NuxtLink>
                    </li>
                </ul>
            </div>
            <div class="grow flex-1">
                <ul class="flex gap-8 items-center justify-end">
                    <li class="text-center">
                        <UtilsSearchLine />
                    </li>
                    <!-- <li class="text-center">
                        <ClientOnly>
                            <WidgetsDarkmodeSwitch />
                        </ClientOnly>
                    </li> -->
                </ul>
            </div>
        </div>
        <div>
            <Transition>
                <LazyLayoutsDefaultCategoryList v-if="categoryOpen" />
            </Transition>
        </div>
    </div>
</template>

<script lang="ts" setup>
import type { PropType } from "vue";

const props = defineProps({
    type: {
        type: String as PropType<"small" | "large">,
        default: "small",
    },
});

const categoryOpen = shallowRef(false);

const route = useRoute();

function handleOpenCategory() {
    categoryOpen.value = !categoryOpen.value;
}

watch(
    () => route.path,
    () => {
        categoryOpen.value = false;
    }
);
</script>

<style scoped>
.v-enter-active,
.v-leave-active {
    transition: all 0.2s ease;
}
.v-enter-from {
    opacity: 0;
    transform: translateY(-15px);
}
.v-leave-to {
    opacity: 0;
    transform: translateY(15px);
}
</style>
